import cx from 'classnames'
import { RawButton } from '@/components/Button'
import styles from './ThumbsRating.module.css'
import { Icon } from '@/components/Icon'
import { FormGroup } from '@/components/Form'

export interface ThumbsRatingProps {
  value?: boolean
  iconSize?: number
  onChange?: (value: boolean) => unknown
}

export function ThumbsRating({
  value = undefined,
  onChange,
  iconSize,
}: ThumbsRatingProps) {
  const createChangeHandler = (newValue: boolean) => () => {
    if (!onChange) {
      return
    }

    if (newValue !== value) {
      onChange(newValue)
    }
  }

  return (
    <FormGroup className={styles.root}>
      <div className={styles.buttons}>
        <ThumbsDown
          value={value}
          iconSize={iconSize}
          onPress={createChangeHandler(false)}
        ></ThumbsDown>
        <ThumbsUp
          value={value}
          iconSize={iconSize}
          onPress={createChangeHandler(true)}
        ></ThumbsUp>
      </div>
    </FormGroup>
  )
}

interface ThumbsProps {
  value?: boolean
  iconSize?: number
  onPress(): unknown
}

function ThumbsDown({ value, onPress, iconSize }: ThumbsProps) {
  return (
    <RawButton
      className={cx(styles.thumbs, value === false && styles.thumbsDown)}
      aria-label="Thumbs down"
      aria-pressed={value === false}
      onPress={onPress}
      style={{ fontSize: iconSize }}
    >
      <Icon auto name="ratings-thumbs-down" />
    </RawButton>
  )
}

function ThumbsUp({ value, onPress, iconSize }: ThumbsProps) {
  return (
    <RawButton
      className={cx(styles.thumbs, value && styles.thumbsUp)}
      aria-label="Thumbs up"
      aria-pressed={value === true}
      onPress={onPress}
      style={{ fontSize: iconSize }}
    >
      <Icon auto name="ratings-thumbs-up" />
    </RawButton>
  )
}
